// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__ea_qM","removeBtn":"styles_removeBtn__qvZ8s"};